import { render, staticRenderFns } from "./PaymentSetting.vue?vue&type=template&id=37e9e2fd&lang=pug"
import script from "./PaymentSetting.vue?vue&type=script&lang=js"
export * from "./PaymentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports